// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2u6yy","item":"PaymentsMobile_item__2_nW0","label":"PaymentsMobile_label__1wvB1","amount":"PaymentsMobile_amount__1Wl5K"};